export default function ContactSection() {
  return (
    <section id="contact" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="max-w-[600px] mx-auto text-center">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-400 mb-3">CONTACT</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">联系我们</h2>
            <p className="mt-3 text-sm text-foreground-500">有任何问题或建议？欢迎通过以下方式与我们取得联系</p>

            <div className="mt-10 bg-background-200/60 rounded-2xl p-8 border border-background-200/40">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mx-auto mb-4">
                    <i className="ri-mail-line text-xl text-primary-400"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-100 mb-1">意见反馈</h3>
                  <p className="text-xs text-foreground-500">feedback@chengquan.tv</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 rounded-xl bg-accent-500/10 flex items-center justify-center mx-auto mb-4">
                    <i className="ri-wechat-line text-xl text-accent-400"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-100 mb-1">微信公众号</h3>
                  <p className="text-xs text-foreground-500">成全影院官方</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 rounded-xl bg-secondary-500/10 flex items-center justify-center mx-auto mb-4">
                    <i className="ri-file-copy-line text-xl text-secondary-400"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-100 mb-1">内容投稿</h3>
                  <p className="text-xs text-foreground-500">content@chengquan.tv</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}